<!-- 机模配 -->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/mouldEquipment/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinbianma')">
            <el-input v-model="yt.conditions.materialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  (conditions = {
                    mouldId: $attrs.mouldEquipment.id,
                    pageSize: 10
                  })
                )
              "
              >{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fudailiao', scope.row, '50%')">
              {{ $t('fudailiao') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row);
                cycleConve();
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/mouldEquipment/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <template #shipeidunwei="scope">
        {{ scope.row.tonnageMin != null && scope.row.tonnageMax != null ? scope.row.tonnageMin + '-' + scope.row.tonnageMax : '' }}
      </template>
      <template #shipeijitai="scope">
        {{ scope.row.equipmentObjects | getEquipmentName }}
      </template>
      <template #biaozhunzhouqimiaomo="scope">
        {{ (scope.row.cycle / 1000).toFixed(1) }}
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required="required" label-width="145px">
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('moqiangshu')" required="required" label-width="145px">
            <!--            <yi_number_input :start.sync="yt.editObj.cavity"-->
            <!--                             :type="'number'" ></yi_number_input>-->
            <el-input-number v-model="yt.editObj.cavity" controls-position="right" :min="1" @change="handleChange"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
            <el-input-number v-model="yt.editObj.actualCavity" controls-position="right" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('biaozhunzhouqimiaomo')" required="required" label-width="145px">
            <yi_number_input :precision="1" :start.sync="yt.editObj.cycle" :type="'number'"> </yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('peijian')">
            <el-input v-model="yt.editObj.components"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mouldEquipment/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required="required" label-width="145px">
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId" disabled></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('moqiangshu')" required="required" label-width="145px">
            <el-input-number v-model="yt.editObj.cavity" controls-position="right" :min="1" @change="handleChange"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
            <el-input-number v-model="yt.editObj.actualCavity" controls-position="right" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('biaozhunzhouqi(miao/mo)')" required="required" label-width="145px">
            <yi_number_input :precision="1" :start.sync="yt.editObj.cycle" :type="'number'"> </yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('peijian')">
            <el-input v-model="yt.editObj.components"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mouldEquipment/update', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 附带料-->
      <template v-if="yt.editObj.action == 'fudailiao'">
        <div class="dialog-scroller">
          <mould_product :mouldEquipment="$attrs.mouldEquipment" :mouldProduct="yt.editObj"></mould_product>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import mould_product from '@@/pages/web/base/mould/mould_product';

export default {
  components: {
    mould_product
  },
  name: 'web_base_mould_mould_equipment',
  data() {
    return {
      columns: [
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'guige',
          prop: 'material.spec'
        },
        {
          label: 'yanse',
          prop: 'material.color'
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient'
        },
        {
          label: 'moqiangshu',
          prop: 'cavity'
        },
        {
          label: 'shijimoqiangshu',
          prop: 'actualCavity'
        },
        {
          label: 'biaozhunzhouqimiaomo',
          type: 'slot'
        },
        {
          label: 'peijian',
          prop: 'components',
          with: 150
        },
        {
          label: 'shifouqiyong',
          prop: 'enabled',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  computed: {
    // maxValue() {
    //   return this.yt.editObj.cavity
    // },
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        mouldId: this.$attrs.mouldEquipment.id
      };
      this.yt.get(1);
    }, 300);
  },
  filters: {
    getEquipmentName(value) {
      return value
        .map(item => {
          return item.name;
        })
        .join(',');
    }
  },
  methods: {
    handleChange(value) {
      console.log(value);
      this.$set(this.yt.editObj, 'actualCavity', value);
    },
    setDefaultValue(action) {
      this.$set(this.yt.editObj, 'cavity', 1);
      this.$set(this.yt.editObj, 'actualCavity', 1);
      this.$set(this.yt.editObj, 'enabled', true);
    },
    cycleConve() {
      this.yt.editObj.cycle = (this.yt.editObj.cycle / 1000).toFixed(1);
    },
    beforeAdd(params, url) {
      params.cycle = params.cycle * 1000;
      console.log('tonnageMin', params.tonnageMin);
      console.log('tonnageMax', params.tonnageMax);
      if (params.tonnageMin != undefined) {
        //如果输入了最小吨位数,没输入最大吨位数,提示用户输入最大吨位数
        if (params.tonnageMax == undefined) {
          // 请输入最大吨位数
          this.utils.errorMessage(this.$t('qingshuruzuidadunweishu'));
          return;
        }
      }
      if (params.tonnageMax != undefined) {
        //如果输入了最大吨位数,没输入最小吨位数,提示用户输入最小吨位数
        if (params.tonnageMin == undefined) {
          // 请输入最大吨位数
          this.utils.errorMessage(this.$t('qingshuruzuixiaodunweishu'));
          return;
        }
      }
      if (params.tonnageMin > params.tonnageMax) {
        this.utils.errorMessage(this.$t('tonnageError'));
        return;
      }
      params.mouldId = this.$attrs.mouldEquipment.id;
      if (params.equipmentId != undefined && params.equipmentId != null) {
        params.equipmentId = params.equipmentId.toString();
      }
      return params;
    }
  }
};
</script>

<style scoped lang="scss">
.shift {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
